// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3xfec","row":"ProcedureTreatmentSummary_row__3Up8w"};